/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import validator from '../helpers/validator';
import upsertPaymentAction from '../redux/actions/payments/upsertPayment';
import Icon from '../components/Icon';
import Loader from '../components/Loader';

const Payment = ({ upsertPaymentAction: upsertPayment, upsert, location }) => {
  const history = useHistory();
  const [cardno, setCardno] = useState('');
  const [cvv, setCvv] = useState('');
  const [phone_number, setPhoneNumber] = useState('');
  const [expirymonth, setExpiryMonth] = useState('');
  const [expiryyear, setExpiryYear] = useState('');
  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [token, setToken] = useState('');
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const urlToken = location.search.slice(
      location.search.indexOf('?token=') + 7,
      location.search.length
    );
    setToken(urlToken);

    if (upsert.status === 'success') {
      setSubmitting(false);
      setErrors([]);
      const data = {
        billCycle: 'monthly',
        method: 'Credit Card',
        card_number: cardno,
        expiry_month: expirymonth,
        expiry_year: expiryyear,
        cvv,
        phone_number,
        amount: 1000,
      };

      if (upsert.message === 'Please provide these details') {
        localStorage.setItem('PAY_PROCEED_DATA', JSON.stringify(data));
        return history.push(`/update-payment/card/proceed/avs?token=${token}`);
      }
      if (upsert.message === 'Please provide your pin') {
        localStorage.setItem('PAY_PROCEED_DATA', JSON.stringify(data));
        return history.push(`/update-payment/card/proceed/pin?token=${token}`);
      }
      setRedirecting(true);
      window.location.assign(upsert.data.payment.authorization.redirect);
    }

    if (upsert.status === 'error') {
      setSubmitting(false);
      return setErrors([upsert.error.message]);
    }

    return undefined;
  }, [upsert]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      billCycle: 'monthly',
      method: 'Credit Card',
      card_number: cardno,
      expiry_month: expirymonth,
      expiry_year: expiryyear,
      phone_number,
      cvv
    };

    const validationErrors = await validator(data);
    if (validationErrors.length > 0) return setErrors(validationErrors);
    setErrors([]);
    setSubmitting(true);
    return upsertPayment('initial', data, token);
  };

  return (
    <>
      <div className="view-container">
        <div className="wrapper-content px-4 bg-dark w-100 m-auto">
          <div className="form-content d-block bg-secondary px-5 py-4">
            <h4 className="text-white text-center xlarge-text">Credit Card</h4>
            <p className="text-white text-center" style={{ fontSize: 15 }}>
              Input Required Field
            </p>

            <div className="centered-icon">
              <div className="bg-dark p-2" style={{ borderRadius: 5 }}>
                <Icon
                  name="creditCard"
                  height={30}
                  width={30}
                  color="#ffffff"
                />
              </div>
            </div>

            {redirecting ? (
              <>
                <Loader />
                <p className="mt-0 text-white text-center">Finishing Up</p>
              </>
            ) : (
              <form action="" className="mt-3">
                {errors.map((error, index) => (
                  <div
                    className="alert alert-danger alert-dismissible"
                    role="alert"
                    key={index}
                  >
                    {error}
                    <button
                      type="button"
                      className="close"
                      onClick={() => setErrors([])}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                ))}
                <div className="form-row">
                  <div className="form-group col-12 mb-1">
                    <label htmlFor="frmCCNum">Card Number</label>
                    <input
                      name="cardnumber"
                      id="frmCCNum"
                      required
                      autoComplete="cc-number"
                      placeholder="XXXX XXXX XXXX XXXX"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className={`form-control dark-input bg-dark text-white ${
                        submitting ? 'cursor-not-allowed' : ''
                      }`}
                      value={cardno.replace(
                        /^(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})$/g,
                        (x, $1, $2, $3, $4) => [$1, $2, $3, $4].filter((group) => !!group).join(' ')
                      )}
                      onChange={(e) => setCardno(e.target.value.replace(/[^\d]/g, ''))}
                      style={{ fontSize: 14 }}
                      maxLength="19"
                      minLength="19"
                      disabled={!!submitting}
                    />
                  </div>
                  <div className="form-group col-6 mb-1">
                    <label htmlFor="cardExpiryMonth">Expiry Month</label>
                    <input
                      name="cc-exp-month"
                      id="frmCCExpMonth"
                      required
                      autoComplete="cc-exp-month"
                      className={`form-control dark-input bg-dark text-white ${
                        submitting ? 'cursor-not-allowed' : ''
                      }`}
                      placeholder="MM"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={expirymonth}
                      onChange={(e) => setExpiryMonth(e.target.value)}
                      style={{ fontSize: 14 }}
                      minLength="2"
                      maxLength="2"
                      disabled={!!submitting}
                    />
                  </div>
                  <div className="form-group col-6 mb-1">
                    <label htmlFor="cardExpiryYear">Expiry Year</label>
                    <input
                      name="cc-exp-year"
                      id="frmCCExpYear"
                      required
                      autoComplete="cc-exp-year"
                      className={`form-control dark-input bg-dark text-white ${
                        submitting ? 'cursor-not-allowed' : ''
                      }`}
                      placeholder="YYYY"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={expiryyear}
                      onChange={(e) => setExpiryYear(e.target.value)}
                      style={{ fontSize: 14 }}
                      minLength="4"
                      maxLength="4"
                      disabled={!!submitting}
                    />
                  </div>
                  <div className="form-group col-12 mb-1">
                    <label htmlFor="cvv">CVV</label>
                    <input
                      name="cvc"
                      id="frmCCCVC"
                      required
                      placeholder="XXX"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="cc-csc"
                      className={`form-control dark-input bg-dark text-white ${
                        submitting ? 'cursor-not-allowed' : ''
                      }`}
                      value={cvv}
                      onChange={(e) => setCvv(e.target.value)}
                      style={{ fontSize: 14 }}
                      minLength="3"
                      maxLength="3"
                      disabled={!!submitting}
                    />
                  </div>
                  <div className="form-group col-12">
                    <label htmlFor="phone_number">Phone Number (To receive OTP)</label>
                    <input
                      id="phone_number"
                      className={`form-control dark-input bg-dark text-white ${
                        submitting ? 'cursor-not-allowed' : ''
                      }`}
                      placeholder="07XXXXXXXX"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={phone_number}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      maxLength="10"
                      minLength="10"
                      style={{ fontSize: 14 }}
                      disabled={!!submitting}
                      required
                    />
                  </div>
                </div>
                <div className="form-group mt-3">
                  {submitting ? (
                    <button
                      type="submit"
                      className="btn btn-secondary py-1 text-white font-weight-bold mt-3 form-control"
                      disabled
                    >
                      Updating
                      <span
                        className="spinner-border spinner-border ml-2"
                        style={{
                          width: '1.5rem',
                          height: '1.5rem',
                          fontSize: '0.7rem',
                        }}
                        role="status"
                        aria-hidden="true"
                      />
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="form-control btn btn-primary text-dark py-1 font-weight-bold mt-3"
                      onClick={handleSubmit}
                    >
                      Update
                    </button>
                  )}
                  <Link to={`/update-payment/select?token=${token}`}>
                    <button
                      type="button"
                      className="form-control btn bg-light-secondary text-white py-1 font-weight-bold mt-3"
                    >
                      Back
                    </button>
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

Payment.propTypes = {
  upsert: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  upsertPaymentAction: PropTypes.func.isRequired,
};

const mapStateProps = ({ upsert }) => ({ upsert });

export default connect(mapStateProps, {
  upsertPaymentAction,
})(Payment);
